// obtenemos la información guardada en localstorage del usuario
function localStorageUser() {
    return JSON.parse(decodeURIComponent(escape(atob(localStorage.getItem('BOCOUS')))));
}

export { localStorageUser };
